import styled from '@emotion/styled'
import { wrap as withStyle, stylesIf } from 'utils/styles'
import { Button } from 'components/patterns'

export default withStyle(
  () => `
    display: flex;
    flex-direction: row-reverse;
  `
)

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'index',
})((props) => {
  const { type, index } = props

  return stylesIf(
    type === 'tertiary' && index === 2,
    `&& { margin-right: auto; }`
  )
})

export const StyledCustomText = styled.span`
  margin-right: 30px;
  margin-top: 15px;
`
